import service from "@/utils/service"

//axios默认就是返回Promise,异步请求
export function login(username, password) {
  const data = {
    username,
    password
  }
  return service({
    url: "/sys/user/login",
    method: "post",
    data: data
  })
}

export function logout() {
  return service({
    url: "/sys/user/logout",
    method: "post"
  })
}

export function getUserInfo() {
  return service({
    url: "/sys/user/info",
    method: "get"
  })
}
